import React from 'react';

import {
  APPROVED,
  AWARDED,
  COMPLETED,
  COUNSELOR_APPROVED,
  DISABLED,
  EARNED,
  IN_PROGRESS,
  LEADER_APPROVED,
  LEADER_SIGNED,
  NOT_STARTED,
  RETIRED,
  STARTED,
} from '@bsa/scouting-js-utils/src/constants/advancements';
import cn from 'classnames';
import PropTypes from 'prop-types';
import {
  MdCheck,
  MdCheckCircle,
  MdOutlineCancel,
  MdPlayCircleFilled,
  MdStar,
} from 'react-icons/md';

import styles from './AdvancementStatus.less';

const propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
};

const StatusIcon = ({ status = '', className = null }) => {
  switch (status) {
    case AWARDED: {
      return (
        <MdStar
          className={cn(styles.requirementIcon, styles[status], className)}
        />
      );
    }
    case COUNSELOR_APPROVED:
    case LEADER_APPROVED:
    case APPROVED: {
      return (
        <MdCheckCircle
          className={cn(styles.requirementIcon, styles[status], className)}
        />
      );
    }
    case EARNED:
    case COMPLETED: {
      return (
        <MdCheck
          className={cn(styles.requirementIcon, styles[status], className)}
        />
      );
    }
    case IN_PROGRESS:
    case LEADER_SIGNED:
    case STARTED: {
      return (
        <MdPlayCircleFilled
          className={cn(styles.requirementIcon, styles[status], className)}
        />
      );
    }
    case NOT_STARTED:
    case DISABLED:
    case RETIRED:
    case 'declined': {
      return (
        <MdOutlineCancel
          className={cn(styles.requirementIcon, styles[status], className)}
        />
      );
    }
    default: {
      return null;
    }
  }
};

StatusIcon.propTypes = propTypes;

export default StatusIcon;
